import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { MEDIA_COOPERATION_LIST, MEDIA_GROUP_PLAYLIST } from 'src/constants/queryKeys';

export const networkGetMediaGroupInfo = async (mediaGroupId) => {
  const res = await axiosInstance.post(`MediaGroup/Info/${mediaGroupId}`);
  return res;
};

export const networkGetMediaGroupList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`MediaGroup/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchMediaGroupList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [MEDIA_GROUP_PLAYLIST, payload, pageIndex],
    queryFn: () => networkGetMediaGroupList(payload, pageIndex, pageSize),
  });
}

export const networkCreateMediaGroup = async (data) => {
  const res = await axiosInstance.post('MediaGroup/Insert', data);
  return res;
};

export const networkUpdateMediaGroup = async (mediaGroupId, data) => {
  const res = await axiosInstance.post(`MediaGroup/Update/${mediaGroupId}`, data);
  return res;
};

export const networkRemoveMediaGroup = async (mediaGroupId) => {
  const res = await axiosInstance.post(`MediaGroup/Remove/${mediaGroupId}`);
  return res;
};

// -------------------------------------------------------------------------

export const networkGetMediaGroupTypeList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`MediaGroupType/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchMediaGroupTypeList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['media-group-type-list', pageIndex],
    queryFn: () => networkGetMediaGroupTypeList(pageIndex, pageSize),
  });
}

export const networkAffiliatedCompany = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`AffiliatedCompany/List/${pageIndex}/${pageSize}`, { ID: 0 });
  return res;
};

export const networkInsertMediaCooperation = async (data) => {
  const res = await axiosInstance.post(`MediaCooperation/Insert`, data);
  return res;
};

export const networkUpdateMediaCooperation = async (mediaCooperationId, data) => {
  const res = await axiosInstance.post(`MediaCooperation/Update/${mediaCooperationId}`, data);
  return res;
};

export const networkRemoveMediaCooperation = async (mediaCooperationId) => {
  const res = await axiosInstance.post(`MediaCooperation/Remove/${mediaCooperationId}`);
  return res;
};

export const networkMediaCooperation = async (filters, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`MediaCooperation/List/${pageIndex}/${pageSize}`, filters);
  return res;
};

export function useFetchMediaCooperationList(filters, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [MEDIA_COOPERATION_LIST, pageIndex],
    queryFn: () => networkMediaCooperation(filters, pageIndex, pageSize),
  });
}
